import ErrorPage from "./ErrorPage";
import { ErrorBoundary } from "react-error-boundary";
import * as Sentry from "@sentry/react";
import Toast from "./Toast";

export default function ReactErrorBoundary(props: any) {
    return (
        <ErrorBoundary
            FallbackComponent={ErrorPage}
            onError={(error,errorInfo) => {
                // log the error
                console.log("Error caught!");
                console.error(error);
                console.error(errorInfo);
                Toast.error('API error',error.message)

                // This inner boundary catches render errors before the outer
                // Sentry.ErrorBoundary can, so forward them to Sentry here.
                Sentry.captureException(error, {
                    contexts: { react: { componentStack: errorInfo.componentStack } },
                });
            }}
            onReset={() => {
                // reloading the page to restore the initial state
                // of the current page
                console.log("reloading the page...");
                window.location.reload();
            }}
        >
            {props.children}
        </ErrorBoundary>
    );
}